import React, { Fragment } from "react";

import { EuiBreadcrumbs, EuiSpacer } from "@elastic/eui";

export default function ManualBreadcrumbs() {
  const breadcrumbs = [
    {
      text: "Übersicht",
      href: "/de/Aussenkameras/IN-9820_QFHD/",
    },
    {
      text: "Spezifikationen",
      href: "/de/Aussenkameras/IN-9820_QFHD/Technische_Spezifikationen/",
    },
    {
      text: "Features",
      href: "/de/Aussenkameras/IN-9820_QFHD/Produkt_Features/",
    },
    {
      text: "Installation",
      href: "/de/Aussenkameras/IN-9820_QFHD/Schnell_Installation/",
    },
    {
      text: "Objektivjustage",
      href: "/de/Aussenkameras/IN-9820_QFHD/Objektivjustage/",
    },
    {
      text: "Handbuch",
      href: "/de/Aussenkameras/IN-9820_QFHD/Handbuch/",
    },
    {
      text: "◄ Außenkameras",
      href: "/de/Aussenkameras/",
    },
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-9420 2k+ WQHD Online Benutzerhandbuch Kapitel"
      />
      <EuiSpacer />
    </Fragment>
  );
}
